export const STUDENTS_GET = 'STUDENTS_GET';
export const ROMBEL_PORTALUSERS_GET = 'ROMBEL_PORTALUSERS_GET';
export const ROMBEL_ADD = 'ROMBEL_ADD';
export const ROMBEL_EDIT = 'ROMBEL_EDIT';
export const STUDENT_ROMBEL_GET = 'STUDENT_ROMBEL_GET';
export const ROMBEL_DELETE = 'ROMBEL_DELETE';
